import React from 'react';
import { useSelector } from 'react-redux';
import { getAdditionalResources } from '../../../redux/slices/resourcesSlices';
import { RootState } from '../../../redux/store';
import { useSearchParams } from 'react-router-dom';
import { CommonResources } from '../CommonResources';

export const AdditionalResources = () => {
  const { additionalResources } = useSelector(
    (state: RootState) => state.resources,
  );

  const [searchParams] = useSearchParams();
  const curriculumId = searchParams.get('curriculumId') ?? '';

  return (
    <CommonResources
      tableData={additionalResources}
      curriculumId={curriculumId}
      getResourceAction={getAdditionalResources}
      resourceTypeLabel={'additionalResources'}
      label="Third-Party Resources"
    />
  );
};
